import { Article } from '@zooplus/checkout-state';

import {
  PREVIEW_ITEM_IMAGE_DIMENSION_COLLAPSED,
  PREVIEW_ITEM_IMAGE_DIMENSION,
} from '@utilities/constants';
import { showFallbackImage } from '@utilities/fallback-image';

import styles from './check-order-item-collapsed.module.scss';

type CheckOrderItemCollapsedProps = Partial<Article> & {
  index: number;
  articlesLength: number;
  numberOfArticlesToShow: number;
};

const CheckOrderItemCollapsed = ({
  name,
  id,
  pictureUrl,
  articlesLength,
  index,
  quantity,
  numberOfArticlesToShow,
}: CheckOrderItemCollapsedProps) => {
  const { WIDTH, HEIGHT } = PREVIEW_ITEM_IMAGE_DIMENSION;

  return (
    <div className={styles.articleCollapsed} data-testid="preview-article-collapsed" key={id}>
      {(articlesLength <= numberOfArticlesToShow || index < numberOfArticlesToShow) && (
        <>
          <img
            loading="lazy"
            data-testid="preview-article-collapsed-image"
            src={pictureUrl}
            alt={name}
            onError={(e) =>
              showFallbackImage(e, {
                width: WIDTH,
                height: HEIGHT,
              })
            }
            width={PREVIEW_ITEM_IMAGE_DIMENSION_COLLAPSED.WIDTH}
            height={PREVIEW_ITEM_IMAGE_DIMENSION_COLLAPSED.HEIGHT}
          />
          {quantity && quantity > 1 && (
            <div className={styles.quantity} data-testid="preview-article-autoshipment-quantity">
              {quantity}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default CheckOrderItemCollapsed;
